import React from 'react';
import { FormattedMessage } from 'react-intl';
import UtilityPageTemplate from '@templates/UtilityPageTemplate';
import { ButtonAsLink } from '@layout';
import messages from './messages';

export const NotFound = ({ history }) => (
  <UtilityPageTemplate title={<FormattedMessage {...messages.title} />}>
    <p>
      <FormattedMessage {...messages.notFound} />
    </p>
    <p>
      Please <ButtonAsLink onClick={history.goBack}>go back</ButtonAsLink>
    </p>
  </UtilityPageTemplate>
);



// WEBPACK FOOTER //
// ./components/pages/NotFound/NotFound.js